window.VegasFav = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');

		let params = {
			_token: App.csrf,
			id: id
		};

		$product.toggleClass('in-fav');

		$.post('/wishlist/toggle', params, function (data) {
			VegasFav.updateCounter($product);
			VegasFav.popup($product);
			VegasFav.updateSidebar();
		});
	},

	del: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.attr('data-id');

		let params = {
			_token: App.csrf,
			id: id
		};

		$('[data-cart][data-id='+ id +']').removeClass('in-fav');

		$.post('/wishlist/toggle', params, function (data) {
			VegasFav.updateCounter();
			$product.slideUp();
		});
	},

	updateCounter: function (product) {
		let newCount,
			$counter = $('[data-counter=fav]'),
			currentCount = parseInt($counter.attr('data-cnt'));

		if(product) {
			if(!product.hasClass('in-fav')) {
				newCount = currentCount - 1;
			} else {
				newCount = currentCount + 1;
			}
		} else {
			newCount = currentCount - 1;
		}

		$counter.attr('data-cnt', newCount);
	},

	popup: function (product) {
		if(!product.hasClass('in-fav')) {
			$.jGrowl("\"" + product.data('title') + "\" убран из моих желаний!");
		} else {
			$.jGrowl("\"" + product.data('title') + "\" добавлен в мои желания!");
		}
	},

	updateSidebar: function () {
		$.get('/wishlist/sidebar', function (data) {
			if (data.view) {
				let $container = $("#sidebar-favorite").find('.vg-shop-fav');
				$container.html(data.view);
			}
		});
	}
};

let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-fav=add]', function () {
	VegasFav.add($(this));
	return false;
});
$document.on('click', '[data-fav=del]', function () {
	VegasFav.del($(this));
	return false;
});